/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { UiFilterListIcon16Light } from './UiFilterListIcon16Light';
import { UiFilterListIcon16Regular } from './UiFilterListIcon16Regular';
import { UiFilterListIcon16Solid } from './UiFilterListIcon16Solid';
import { UiFilterListIcon20Light } from './UiFilterListIcon20Light';
import { UiFilterListIcon20Regular } from './UiFilterListIcon20Regular';
import { UiFilterListIcon20Solid } from './UiFilterListIcon20Solid';
import { UiFilterListIcon24Regular } from './UiFilterListIcon24Regular';
import { UiFilterListIcon24Solid } from './UiFilterListIcon24Solid';
import { UiFilterListIcon32Regular } from './UiFilterListIcon32Regular';
import { UiFilterListIcon64Regular } from './UiFilterListIcon64Regular';
var sizes = {
    16: {
        light: UiFilterListIcon16Light,
        regular: UiFilterListIcon16Regular,
        solid: UiFilterListIcon16Solid,
    },
    20: {
        light: UiFilterListIcon20Light,
        regular: UiFilterListIcon20Regular,
        solid: UiFilterListIcon20Solid,
    },
    24: {
        regular: UiFilterListIcon24Regular,
        solid: UiFilterListIcon24Solid,
    },
    32: {
        regular: UiFilterListIcon32Regular,
    },
    64: {
        regular: UiFilterListIcon64Regular,
    },
};
export var UiFilterListIcon = forwardRef('UiFilterListIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
